import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { PrepayService } from '@app/services/myoffice/prepay/prepay.service';
import { countPrepay, countPrepayDetails, countPrepayDetailsFailure, countPrepayDetailsSuccess, countPrepayFailure, countPrepaySuccess, deletePrepay, deletePrepayFailure, deletePrepaySuccess, savePrepay, savePrepayFailure, savePrepaySuccess, searchPrepay, searchPrepayDetails, searchPrepayDetailsFailure, searchPrepayDetailsId, searchPrepayDetailsIdFailure, searchPrepayDetailsIdSuccess, searchPrepayDetailsSuccess, searchPrepayFailure, searchPrepaySuccess, sumPrepay, sumPrepayDetails, sumPrepayDetailsFailure, sumPrepayDetailsSuccess, sumPrepayFailure, sumPrepaySuccess } from '@app/actions/myoffice/prepay/prepay.action';

@Injectable()
export class PrepayEffect {
    constructor(
        private _actions$: Actions,
        private prepayService: PrepayService
      ) { }

    savePrepay$ = createEffect(() => this._actions$.pipe(
        ofType(savePrepay),
        mergeMap(({ params }) => this.prepayService.savePrepay(params).pipe(
            map(res => savePrepaySuccess({ result: res })),
            catchError(res => of(savePrepayFailure({ msg: res })))
        ))
    ));

    searchPrepay$ = createEffect(() => this._actions$.pipe(
        ofType(searchPrepay),
        mergeMap(({ params }) => this.prepayService.searchPrepay(params).pipe(
          map(res => searchPrepaySuccess({ prepay: res })),
          catchError(msg => of(searchPrepayFailure({ msg: msg })))
        ))
    ));

    countPrepay$ = createEffect(() => this._actions$.pipe(
        ofType(countPrepay),
        mergeMap(({ params }) => this.prepayService.countPrepay(params).pipe(
          map(res => countPrepaySuccess({ count: res })),
          catchError(msg => of(countPrepayFailure({ msg: msg })))
        ))
    ));

    sumPrepay$ = createEffect(() => this._actions$.pipe(
      ofType(sumPrepay),
      mergeMap(({ params }) => this.prepayService.sumPrepay(params).pipe(
        map(res => sumPrepaySuccess({ sum: res })),
        catchError(msg => of(sumPrepayFailure({ msg: msg })))
      ))
    ));

    searchPrepayDetails$ = createEffect(() => this._actions$.pipe(
      ofType(searchPrepayDetails),
      mergeMap(({ params }) => this.prepayService.searchPrepayDetails(params).pipe(
        map(res => searchPrepayDetailsSuccess({ prepay: res })),
        catchError(msg => of(searchPrepayDetailsFailure({ msg: msg })))
      ))
    ));

    countPrepayDetails$ = createEffect(() => this._actions$.pipe(
      ofType(countPrepayDetails),
      mergeMap(({ params }) => this.prepayService.countPrepayDetails(params).pipe(
        map(res => countPrepayDetailsSuccess({ count: res })),
        catchError(msg => of(countPrepayDetailsFailure({ msg: msg })))
      ))
    ));

    sumPrepayDetails$ = createEffect(() => this._actions$.pipe(
      ofType(sumPrepayDetails),
      mergeMap(({ params }) => this.prepayService.sumPrepayDetails(params).pipe(
        map(res => sumPrepayDetailsSuccess({ sum: res })),
        catchError(msg => of(sumPrepayDetailsFailure({ msg: msg })))
      ))
    ));

    searchPrepayDetailsId$ = createEffect(() => this._actions$.pipe(
      ofType(searchPrepayDetailsId),
      mergeMap(({ userid }) => this.prepayService.searchPrepayDetailsId(userid).pipe(
        map(res => searchPrepayDetailsIdSuccess({ prepay: res })),
        catchError(msg => of(searchPrepayDetailsIdFailure({ msg: msg })))
      ))
    ));


    deletePrepay$ = createEffect(() => this._actions$.pipe(
      ofType(deletePrepay),
      mergeMap(({ userid,moneyno }) => this.prepayService.deletePrepay(userid, moneyno).pipe(
          map(res => deletePrepaySuccess({ result: res })),
          catchError(res => of(deletePrepayFailure({ msg: res })))
      ))
  ));

}